import React, { useContext, useState, useEffect } from "react";
import Buttons from "./Buttons";
import {withRouter} from 'react-router-dom'
import MainContext from '../../state/main/mainContext'
import ReactGA from 'react-ga';

const Modal4 = ({ history: {push} }) => {
  const [errorMsg, setErrorMsg] = useState();
  const [seeError, setSeeError] = useState(false);
  const mainContext = useContext(MainContext)
  const {onChange, formData: { age }} = mainContext;

  useEffect(() => {
    ReactGA.pageview(window.location.pathname); 
  }, [])

  const moveForward = () => {
    if (age === "" || age === null) {
      setErrorMsg("Please enter your age");
      setSeeError(true);
      console.log("wrong");
      return;
    }
    push('/survey/4')
  };
  const preventSubmit = (e) => {
    e.key === "Enter" && e.preventDefault();
  };
  return (
    <section id="modal-4">
      <div className="container">
        <h2 style={{ visibility: "hidden" }}>How old are you?</h2>
        <h2>How old are you?</h2>
        <div className="form">
          <input
            type="number"
            name="age"
            value={age}
            onChange={onChange}
            onKeyPress={preventSubmit}
            placeholder="16"
          />
          {seeError && <p className="errorMsg">{errorMsg}</p>}
        </div>
        <Buttons advance={moveForward} goBack={() => {push('/survey/2')}}  />
      </div>
    </section>
  );
};

export default withRouter(Modal4);
